export default __webpack_public_path__ + "static/media/WNo.8-4.0493cdf5.jpg";